Vue.component('SecondaryPillButton',
    require('./components/elements/SecondaryPillButton').default
)

Vue.component('PillNavigation',
    require('./components/elements/PillNavigation').default
)

Vue.component('PrimaryNavigation',
    require('./components/PrimaryNavigation').default
)

Vue.component('SystemFooter',
    require('./components/SystemFooter').default
)

Vue.component('LayoutNotifications',
    require('./components/LayoutNotifications').default
)

Vue.component('LayoutApprovals',
    require('./components/LayoutApprovals').default
)

Vue.component('LayoutChangelog',
    require('./components/LayoutChangelog').default
)

Vue.component('HeroErrorMessage',
    require('./components/elements/HeroErrorMessage').default
)

Vue.component('ScreenLock',
    require('./components/ScreenLock').default
)

Vue.component('Launcher',
    require('./components/elements/launcher/Launcher').default
)

Vue.component('DateRangePicker',
    require('./components/forms/controls/DateRangePicker').default
)

Vue.component('KeenCategorySelector',
    require('./components/forms/controls/KeenCategorySelector').default
)

Vue.component('NewDealModal',
    require('./components/deals/NewDealModal').default
)

Vue.component('TableMetaElement',
    require('./components/TableMetaElement').default
)

Vue.component('TableSortAndFilterElement',
    require('./components/TableSortAndFilterElement').default
)

Vue.component('FilterTextbox',
    require('./components/forms/controls/FilterTextbox').default
)

Vue.component('FilterVehiclePicker',
    require('./components/forms/controls/FilterVehiclePicker').default
)

Vue.component('FilterExpenseCategoryWrapper',
    require('./components/FilterExpenseCategoryWrapper').default
)

Vue.component('VehiclePicker',
    require('./components/forms/controls/KeenVehiclePicker').default
)

Vue.component('HeaderSearch', 
    require('./components/search/HeaderSearch').default
)

Vue.component('Avatar',
    require('./components/elements/Avatar').default
)

Vue.component('TitleViewSelector',
    require('./components/TitleViewSelector').default
)

Vue.component('VueInput',
    require('./components/forms/controls/Input').default
)

Vue.component('VueSelect',
    require('./components/forms/controls/Select').default
)

Vue.component('VueCheckBox',
    require('./components/forms/controls/Checkbox').default
)

Vue.component('KeenDateRangePicker',
    require('./components/forms/controls/KeenDateRangePicker').default
)

Vue.component('KeenDatePicker',
    require('./components/forms/controls/KeenDatePicker').default
)

Vue.component('KeenTeamMemberPicker',
    require('./components/forms/controls/KeenTeamMemberPicker').default
)

Vue.component('KeenLeadPicker',
    require('./components/forms/controls/KeenLeadPicker').default
)

Vue.component('KeenBasicContactInput',
    require('./components/forms/controls/KeenBasicContactInput').default
)

Vue.component('KeenContactPicker',
    require('./components/forms/controls/KeenContactPicker').default
)

Vue.component('KeenLocationPicker',
    require('./components/forms/controls/KeenLocationPicker').default
)

Vue.component('KeenLeadStagePicker',
    require('./components/forms/controls/KeenLeadStagePicker').default
)

Vue.component('KeenReferralSourcePicker',
    require('./components/forms/controls/KeenReferralSourcePicker').default
)

Vue.component('PriceBetweenSelector',
    require('./components/forms/controls/PriceBetweenSelector').default
)

Vue.component('GenericBetweenSelector',
    require('./components/forms/controls/GenericBetweenSelector').default
)

Vue.component('CogLoader',
    require('./components/elements/CogLoader').default
)

Vue.component('ContactNameAndDetails',
    require('./components/elements/ContactNameAndDetails').default
)

Vue.component('VehicleDescription', 
    () => import('./components/elements/VehicleDescription'/* webpackChunkName: "vehicle-description" */)
)

Vue.component('VehicleRegistrationTitle', 
    () => import('./components/elements/VehicleRegistrationTitle'/* webpackChunkName: "vehicle-registration-title" */)
)